<template>
  <div>
    <div class="" style="">
      <div
        style="
          height: 45px;
          background: #2c2d31;
          line-height: 45px;
          color: #e6e6e6;
          font-size: 12px;
        "
      >
        <img
          :src="teamLogo + player.team.id"
          style="width: 20px; margin-left: 10px"
          alt=""
        />
        {{ player.team.name | transliterate(cookiesObject.lang) }}
      </div>
      <div>
        <div style="background: #212225; height: 140px; line-height: 140px">
          <img
            :src="httpReq + '/player/logo/' + id"
            alt=""
            style="
              margin-left: 20px;
              width: 90px;
              background: lightgrey;
              border-radius: 2px;
            "
          />
          <span
            style="
              color: lightgrey;
              font-weight: 550;
              margin-left: 10px;
              font-size: 14px;
            "
          >
            <span v-if="player.shortName">{{
              player.shortName | transliterate(cookiesObject.lang)
            }}</span>
            <span v-else>{{
              player.commonName | transliterate(cookiesObject.lang)
            }}</span></span
          >
        </div>
      </div>
      <b-tabs
        v-model="tabIndex"
        class="Some"
        style="border-radius: 0px; color: white; background: #2c2d31"
        nav-class="ks1"
        active-nav-item-class="ks"
      >
        <b-tab style="border-radius: 0px">
          <template v-slot:title>
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: #e6e6e6;
                font-size: 12px;
                line-height: 25px;
              "
              v-if="tabIndex == 0"
            >
              {{ $t("LanguageEn.profile") }}
            </p>
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: grey;
                font-size: 12px;
                line-height: 25px;
              "
              v-else
            >
              {{ $t("LanguageEn.profile") }}
            </p>
          </template>
          <div style="background: #141416">
            <li
              class=""
              style="list-style-type: none; height: 10px; background: #141416"
            ></li>
            <li
              class=""
              style="
                list-style-type: none;
                height: 34px;
                line-height: 34px;
                background: #212225;
                padding-left: 10px;
                font-size: 11px;
              "
            >
              {{ $t("LanguageEn.profileDet") }}
            </li>
            <div class="container">
              <ul
                class="pl-0 pr-0"
                style="
                  list-style-type: none;
                  padding-left: 0px;
                  color: #e6e6e6;
                  font-size: 11px;
                "
              >
                <li
                  class="row"
                  style="
                    padding-left: 10px;
                    height: 34px;
                    line-height: 34px;
                    border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                  "
                >
                  <span class="col-3" style="color: grey">
                    {{ $t("LanguageEn.country") }}:
                  </span>
                  <span class="col" style="" v-if="player.country"
                    ><img
                      :src="catLogo + player.country.id"
                      style="width: 20px; margin-right: 2px"
                      alt=""
                    />
                    {{
                      player.country.name | transliterate(cookiesObject.lang)
                    }}
                  </span>
                </li>
                <li
                  class="row"
                  style="
                    padding-left: 10px;
                    height: 34px;
                    line-height: 34px;
                    border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                  "
                >
                  <span class="col-3" style="color: grey">
                    {{ $t("LanguageEn.team") }}:
                  </span>
                  <span class="col" style="" v-if="player.team"
                    ><router-link
                      style="color: #e6e6e6"
                      id="router-link"
                      :to="{
                        name: 'teamPagePar',
                        params: { id: player.team.id, name: player.team.name },
                      }"
                      ><img
                        :src="teamLogo + player.team.id"
                        style="width: 20px; margin-right: 2px"
                        alt=""
                      />{{
                        player.team.name | transliterate(cookiesObject.lang)
                      }}
                    </router-link>
                  </span>
                </li>
                <li
                  class="row"
                  style="
                    padding-left: 10px;
                    height: 34px;
                    line-height: 34px;
                    border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                  "
                >
                  <span class="col-3" style="color: grey">
                    {{ $t("LanguageEn.age") }}:
                  </span>
                  <span class="col" style="" v-if="player.birthdate">
                    {{
                      (new Date().getFullYear() - player.birthdate.slice(0, 4))
                        | transliterate(cookiesObject.lang)
                    }}
                    years</span
                  >
                </li>
                <li
                  class="row"
                  style="
                    padding-left: 10px;
                    height: 34px;
                    line-height: 34px;
                    border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                  "
                >
                  <span class="col-3" style="color: grey">
                    {{ $t("LanguageEn.height") }}:
                  </span>
                  <span class="col" style="" v-if="player.height">
                    {{ player.height | transliterate(cookiesObject.lang) }}
                  </span>
                </li>
                <li
                  class="row"
                  style="
                    padding-left: 10px;
                    height: 34px;
                    line-height: 34px;
                    border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                  "
                >
                  <span class="col-3" style="color: grey">
                    {{ $t("LanguageEn.weight") }}:
                  </span>
                  <span class="col" style="" v-if="player.weight">
                    {{ player.weight | transliterate(cookiesObject.lang) }}
                  </span>
                </li>
                <li
                  class="row"
                  style="
                    padding-left: 10px;
                    height: 34px;
                    line-height: 34px;
                    border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                  "
                >
                  <span class="col-3" style="color: grey">
                    {{ $t("LanguageEn.birth") }}:
                  </span>
                  <span class="col" style="" v-if="player.birthPlace">
                    {{ player.birthPlace | transliterate(cookiesObject.lang) }}
                  </span>
                </li>
                <li
                  class="row"
                  style="
                    padding-left: 10px;
                    height: 34px;
                    line-height: 34px;
                    border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                  "
                >
                  <span class="col-3" style="color: grey">
                    {{ $t("LanguageEn.birthDate") }}:
                  </span>
                  <span class="col" style="" v-if="player.birthdate">
                    {{ player.birthdate | transliterate(cookiesObject.lang) }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </b-tab>
        <b-tab style="border-radius: 0px">
          <template v-slot:title>
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: white;
                font-size: 12px;
                line-height: 25px;
              "
              v-if="tabIndex == 1"
            >
              {{ $t("LanguageEn.txtStatistics") }}
            </p>
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: grey;
                font-size: 12px;
                line-height: 25px;
              "
              v-else
            >
              {{ $t("LanguageEn.txtStatistics") }}
            </p>
          </template>
          <div style="background: #141416">
            <ul
              class="pl-0 pr-0"
              style="
                list-style-type: none;
                padding-left: 0px;
                color: #e6e6e6;
                font-size: 11px;
              "
            >
              <li class="" style="height: 10px; background: #141416"></li>
              <div class="container">
                <div
                  v-for="(some, ind) in sqData"
                  :key="ind"
                  style="margin-top: 10px"
                >
                  <div
                    class="row"
                    style="
                      color: #e6e6e6;
                      height: 34px;
                      line-height: 34px;
                      background: #212225;
                      font-size: 15px;
                    "
                  >
                    <span class="col">
                      {{
                        some.season.tournament.name
                          | transliterate(cookiesObject.lang)
                      }}
                      <span style="float: right"
                        ><img
                          :src="teamLogo + some.team.id"
                          style="
                            width: 23px;
                            margin-left: 3px;
                            margin-right: 3px;
                          "
                          alt="team"
                        />
                        <span class="MobileHide">{{
                          some.team.name | transliterate(cookiesObject.lang)
                        }}</span>
                        <span class="MobileShow">
                          <span v-if="some.team.shortCode">{{
                            some.team.shortCode
                              | transliterate(cookiesObject.lang)
                          }}</span>
                          <span v-else>{{
                            some.team.name.slice(0, 3)
                              | transliterate(cookiesObject.lang)
                          }}</span>
                        </span>
                      </span></span
                    >
                  </div>
                  <div class="row" style="margin-top: 10px; font-size: 14px">
                    <div class="col">
                      <p>
                        {{ $t("LanguageEn.number") }}:
                        <span style="float: right" v-if="some.squadData.number">
                          {{
                            some.squadData.number
                              | transliterate(cookiesObject.lang)
                          }}
                        </span>
                        <span style="float: right" v-else> - </span>
                      </p>
                      <p>
                        {{ $t("LanguageEn.position") }}:
                        <span
                          style="float: right"
                          v-if="some.squadData.position_id == 1"
                          >GK</span
                        >
                        <span
                          style="float: right"
                          v-else-if="some.squadData.position_id == 2"
                          >DF</span
                        >
                        <span
                          style="float: right"
                          v-else-if="some.squadData.position_id == 3"
                          >MF</span
                        >
                        <span
                          style="float: right"
                          v-else-if="some.squadData.position_id == 4"
                          >FW</span
                        >
                      </p>
                      <p>
                        {{ $t("LanguageEn.apps") }}:
                        <span
                          style="float: right"
                          v-if="some.squadData.appearences"
                        >
                          {{
                            some.squadData.appearences
                              | transliterate(cookiesObject.lang)
                          }}
                        </span>
                        <span style="float: right" v-else> - </span>
                      </p>
                      <p>
                        {{ $t("LanguageEn.lineups") }}:
                        <span
                          style="float: right"
                          v-if="some.squadData.lineups"
                        >
                          {{
                            some.squadData.lineups
                              | transliterate(cookiesObject.lang)
                          }}
                        </span>
                        <span style="float: right" v-else> - </span>
                      </p>
                      <p>
                        {{ $t("LanguageEn.minutes") }}:
                        <span
                          style="float: right"
                          v-if="some.squadData.minutes"
                        >
                          {{
                            some.squadData.minutes
                              | transliterate(cookiesObject.lang)
                          }}
                        </span>
                        <span style="float: right" v-else> - </span>
                      </p>
                      <p>
                        {{ $t("LanguageEn.yellowcards") }}:
                        <span
                          style="float: right"
                          v-if="some.squadData.yellowcards"
                        >
                          {{
                            some.squadData.yellowcards
                              | transliterate(cookiesObject.lang)
                          }}
                        </span>
                        <span style="float: right" v-else> - </span>
                      </p>
                      <p>
                        {{ $t("LanguageEn.redcards") }}:
                        <span
                          style="float: right"
                          v-if="some.squadData.redcards"
                        >
                          {{
                            some.squadData.redcards
                              | transliterate(cookiesObject.lang)
                          }}
                        </span>
                        <span style="float: right" v-else> - </span>
                      </p>
                    </div>
                    <div class="col" v-if="some.squadData.position_id != 1">
                      <p>
                        {{ $t("LanguageEn.goals") }}:
                        <span style="float: right" v-if="some.squadData.goals">
                          {{
                            some.squadData.goals
                              | transliterate(cookiesObject.lang)
                          }}
                        </span>
                        <span style="float: right" v-else> - </span>
                      </p>
                      <p>
                        {{ $t("LanguageEn.assists") }}:
                        <span
                          style="float: right"
                          v-if="some.squadData.assists"
                        >
                          {{
                            some.squadData.assists
                              | transliterate(cookiesObject.lang)
                          }}
                        </span>
                        <span style="float: right" v-else> - </span>
                      </p>
                      <p>
                        {{ $t("LanguageEn.shotsAccuracy") }}:
                        <span
                          style="float: right"
                          v-if="some.squadData.shots_on_target"
                        >
                          {{
                            (
                              (some.squadData.shots_on_target /
                                some.squadData.shots_total) *
                              100
                            ).toFixed(2) | transliterate(cookiesObject.lang)
                          }}
                          %
                        </span>
                        <span style="float: right" v-else> - </span>
                      </p>
                      <p>
                        {{ $t("LanguageEn.crossAccuracy") }}:
                        <span
                          style="float: right"
                          v-if="some.squadData.crosses_accurate"
                        >
                          {{
                            (
                              (some.squadData.crosses_accurate /
                                some.squadData.crosses_total) *
                              100
                            ).toFixed(2) | transliterate(cookiesObject.lang)
                          }}
                          %
                        </span>
                        <span style="float: right" v-else> - </span>
                      </p>
                      <p>
                        {{ $t("LanguageEn.passesAccuracy") }}:
                        <span
                          style="float: right"
                          v-if="some.squadData.passes_accuracy"
                        >
                          {{
                            some.squadData.passes_accuracy
                              | transliterate(cookiesObject.lang)
                          }}
                          %
                        </span>
                        <span style="float: right" v-else> - </span>
                      </p>
                      <p>
                        {{ $t("LanguageEn.tacklesPerGame") }}:
                        <span
                          style="float: right"
                          v-if="some.squadData.tackles"
                        >
                          {{
                            (
                              some.squadData.tackles /
                              some.squadData.appearences
                            ).toFixed(2) | transliterate(cookiesObject.lang)
                          }}
                        </span>
                        <span style="float: right" v-else> - </span>
                      </p>
                      <p>
                        {{ $t("LanguageEn.rating") }}:
                        <span style="float: right" v-if="some.squadData.rating">
                          {{
                            some.squadData.rating
                              | transliterate(cookiesObject.lang)
                          }}
                        </span>
                      </p>
                    </div>
                    <div class="col" v-else>
                      <p>
                        {{ $t("LanguageEn.redcards") }}:
                        <span
                          style="float: right"
                          v-if="some.squadData.redcards"
                          >{{
                            some.squadData.redcards
                              | transliterate(cookiesObject.lang)
                          }}
                        </span>
                        <span style="float: right" v-else> - </span>
                      </p>
                      <p>
                        {{ $t("LanguageEn.savesPerGame") }}:
                        <span style="float: right" v-if="some.squadData.saves"
                          >{{
                            (
                              some.squadData.saves / some.squadData.appearences
                            ).toFixed(2) | transliterate(cookiesObject.lang)
                          }}
                        </span>
                        <span style="float: right" v-else> - </span>
                      </p>
                      <p>
                        {{ $t("LanguageEn.cleanSheets") }}:
                        <span
                          style="float: right"
                          v-if="some.squadData.cleansheets"
                          >{{
                            some.squadData.cleansheets
                              | transliterate(cookiesObject.lang)
                          }}
                        </span>
                        <span style="float: right" v-else> - </span>
                      </p>
                      <p>
                        {{ $t("LanguageEn.penaltySaves") }}:
                        <span
                          style="float: right"
                          v-if="some.squadData.penalties_saves"
                          >{{
                            some.squadData.penalties_saves
                              | transliterate(cookiesObject.lang)
                          }}
                        </span>
                        <span style="float: right" v-else> - </span>
                      </p>
                      <p>
                        {{ $t("LanguageEn.rating") }}:
                        <span style="float: right" v-if="some.squadData.rating"
                          >{{
                            some.squadData.rating
                              | transliterate(cookiesObject.lang)
                          }}
                        </span>
                        <span style="float: right" v-else> - </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </ul>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PlayerPage",
  data() {
    return {
      cookiesObject: "",
      player: "",
      id: "",
      statistics: "",
      tabIndex: 0,
      teamLogo: "https://sportapi.zuniac.com/team/logo/",
      catLogo: "https://sportapi.zuniac.com/category/logo/",
      sqData: [],
    };
  },

  mounted() {
    this.id = this.$route.params.id;

    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;

    var myHeaders = new Headers();
    myHeaders.append(
      "Cookie",
      "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      this.httpReq + "/player/" + this.id + "?token=" + cookiesObject.token,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        this.player = result.player;
        this.statistics = result.player.topScorers;
        this.sqData = result.squad;

        this.sqData = this.sqData.sort(function (a, b) {
          return parseInt(b.season.name) - parseInt(a.season.name);
        });
      })
      .catch((error) => console.log("error", error));
  },

  props: {},
  computed: {
    ...mapGetters(["httpReq"]),
  },

  watch: {},
};
</script>

<style scoped>
.bbg {
  background: #d6d6d6;
}

@media only screen and (max-width: 770px) {
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
